import React from 'react';
import { Button, colors, Modal } from '@insurancemenu/imenu-components-lib';
import FormSpinner from 'components/common/general/FormSpinner';
import { iconLayout, ModalType } from 'global/utils/ModalsHelper';
import { createStyles } from './styles';

interface ActionModalProps {
  id?: string;
  show: boolean;
  title: string | JSX.Element;
  subtitle?: string | JSX.Element;
  modalContent?: JSX.Element;
  actionButtonText?: string;
  closeButtonText?: string;
  showCloseButton?: boolean;
  onClose: () => void;
  onAction?: () => void;
  modalType?: ModalType;
  icon?: JSX.Element;
  loading?: boolean;
  closable?: boolean;
  isValid?: boolean;
}

const ActionModal = ({
  show,
  id,
  title,
  subtitle,
  modalContent = <></>,
  actionButtonText,
  closeButtonText,
  showCloseButton = true,
  onClose,
  onAction,
  icon,
  modalType = ModalType.WARNING,
  loading = false,
  closable = true,
  isValid = true,
}: ActionModalProps): JSX.Element => {
  const classes = createStyles(!!subtitle);

  return (
    <Modal show={show} onClose={onClose} className={classes.modal} closable={closable} id={id}>
      {icon || iconLayout(modalType, classes.icon)}
      <p className={classes.modalTitle}>{title}</p>
      {subtitle && <div className={classes.contentText}>{subtitle}</div>}
      {modalContent}
      <footer className={classes.modalFooter}>
        {showCloseButton && (
          <Button type="outlined" onClick={onClose} size="large">
            {closeButtonText || 'Close'}
          </Button>
        )}
        {onAction && (
          <Button
            className={classes.actionButton}
            color={modalType === ModalType.DELETE ? 'custom' : 'primary'}
            customColor={modalType === ModalType.DELETE ? colors.red[600] : colors.blue[600]}
            onClick={onAction}
            size="large"
            disabled={loading || !isValid}
          >
            {actionButtonText || 'Save'}
          </Button>
        )}
      </footer>
      <FormSpinner display={loading} />
    </Modal>
  );
};

export default ActionModal;
